import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 如果该路由的目录同时存在index.js和index.vue文件，则一定要写全index.vue(不能不写.vue后缀！！！否则找到的是index.js文件，会报错！！)
export const routes = [{
		path: '/',
		component: (resolve) => require(['@/views/index/index.vue'], resolve),
		redirect: '/login',
		children: [{
			path: '/weiyuncang',
			meta: {
				title: '微云仓'
			},
			component: (resolve) => require(['@/views/index/components/weiYunCang/index.vue'], resolve)
		}, {
			path: '/huogeili',
			meta: {
				title: '货给力'
			},
			component: (resolve) => require(['@/views/index/components/huoGeiLi/index.vue'], resolve)
		}, {
			path: '/classiccase',
			meta: {
				title: '经典案例'
			},
			component: (resolve) => require(['@/views/index/components/classiccase/index.vue'], resolve)
		}, {
			path: '/service',
			meta: {
				title: '联系客服'
			},
			component: (resolve) => require(['@/views/index/components/service/index.vue'], resolve)
		}, {
			path: '/channel',
			meta: {
				title: '渠道合作'
			},
			component: (resolve) => require(['@/views/index/components/channel/index.vue'], resolve)
		}, {
			path: '/about',
			meta: {
				title: '关于候鸟'
			},
			component: (resolve) => require(['@/views/index/components/about/index.vue'], resolve)
		}]
	},
	{
		name: 'index',
		path: '/index',
		meta: {
			title: '候鸟供应链'
		},
		component: () => import('@/views/index/index.vue')
	},
	{
		name: 'register',
		path: '/register',
		meta: {
			title: '注册'
		},
		component: () => import('@/views/register/index.vue')
	},
	{
		name: 'login',
		path: '/login',
		meta: {
			title: '登录'
		},
		component: (resolve) => require(['@/views/index/components/login/index.vue'], resolve)
	},
	{
		name: 'home',
		path: '/home',
		meta: {
			title: '首页'
		},
		component: () => import('@/views/home/index.vue')
	},
	{
		name: 'search',
		path: '/search',
		meta: {
			title: '搜索'
		},
		component: () => import('@/views/search/index.vue')
	},
	{
		name: 'flashbuy',
		path: '/flashbuy',
		meta: {
			title: '特划算'
		},
		component: () => import('@/views/flashbuy/flashbuy-list/index.vue')
	},
	{
		name: 'flashbuyDetail',
		path: '/flashbuyDetail',
		meta: {
			title: ''
		},
		component: () => import('@/views/flashbuy/flashbuy-detail/index.vue')
	},
	{
		name: 'vipZone',
		path: '/vipZone',
		meta: {
			title: '会员'
		},
		component: () => import('@/views/vipZone/vipZone/index.vue')
	},
	{
		name: 'enjoyDongdong',
		path: '/enjoyDongdong',
		meta: {
			title: ''
		},
		component: () => import('@/views/enjoyDongdong/index.vue')
	},
	// {
	// 	name: 'test',
	// 	path: '/test',
	// 	meta:{
	// 		title:'搜索'
	// 	},
	// 	component: () => import('@/views/test/newspaperContent.vue')
	// },
	{
		name: 'shoppingCart',
		path: '/shoppingCart',
		meta: {
			title: '我的购物车'
		},
		component: () => import('@/views/shoppingCart/index.vue')
	},
	{
		name: 'submitOrder',
		path: '/submitOrder',
		meta: {
			title: '提交订单'
		},
		component: () => import('@/views/submitOrder/index.vue')
	},
	{
		name: 'payment',
		path: '/payment',
		meta: {
			title: '收银台'
		},
		component: () => import('@/views/payment/index.vue')
	},
	{
		name: 'bondedPayment',
		path: '/bondedPayment',
		meta: {
			title: '收银台'
		},
		component: () => import('@/views/payment/bondedPayment.vue')
	},
	{
		name: 'recharge',
		path: '/recharge',
		meta: {
			title: '收银台'
		},
		component: () => import('@/views/recharge/index.vue')
	},
	{
		name: 'kingBar',
		path: '/kingBar',
		meta: {
			title: ''
		},
		component: () => import('@/views/kingBar/index.vue')
	},
	{
		name: 'JDGoodsInfo',
		path: '/JDGoodsInfo',
		meta: {
			title: ''
		},
		component: () => import('@/views/JDGoodsInfo/index.vue')
	},
	{
		name: 'groupRotation',
		path: '/groupRotation',
		meta: {
			title: ''
		},
		component: () => import('@/views/groupRotation/index.vue')
	},
	{
		name: 'WeeklyInfo',
		path: '/WeeklyInfo',
		meta: {
			title: ''
		},
		component: () => import('@/views/WeeklyInfo/index.vue')
	},
	{
		name: 'adDetails',
		path: '/adDetails',
		meta: {
			title: ''
		},
		component: () => import('@/views/adDetails/index.vue')
	},
	{
		name: 'grouping',
		path: '/grouping',
		meta: {
			title: ''
		},
		component: () => import('@/views/grouping/index.vue')
	},
	{
		name: 'dailyRobbing',
		path: '/activity/dailyRobbing',
		meta: {
			title: '每日必抢'
		},
		component: () => import('@/views/activity/dailyRobbing/index.vue')
	},
	{
		name: 'goodsDetails',
		path: '/goodsDetails',
		meta: {
			title: '商品详情'
		},
		component: () => import('@/views/goodsDetails/index.vue')
	},
	{
		name: 'dailyPromotion',
		path: '/dailyPromotion',
		meta: {
			title: '每日推品'
		},
		component: () => import('@/views/dailyPromotion/index.vue')
	},
	{
		name: 'user',
		path: '/user',
		redirect: '/user/center',
		component: () => import('@/views/user/newIndex.vue'),
		children: [
			{
				name: 'KttOrderList',
				path: 'KttOrderList',
				meta: {
					title: '快团团订单列表'
				},
				component: () => import('@/views/user/components/KttOrderList/index.vue'),
			},
			{
				name: 'KttOpeningList',
				path: 'KttOpeningList',
				meta: {
					title: '快团团开团列表'
				},
				component: () => import('@/views/user/components/KttOpeningList/index.vue'),
			},
			{
				name: 'productLibrary',
				path: 'productLibrary',
				meta: {
					title: '商品库'
				},
				component: () => import('@/views/user/components/productLibrary/index.vue'),
			},{
				name: 'exportGoods',
				path: 'exportGoods',
				meta: {
					title: '选品导出'
				},
				component: () => import('@/views/user/components/exportGoods/index.vue'),
			}, {
				name: 'exportCostGoods',
				path: 'exportCostGoods',
				meta: {
					title: '特划算'
				},
				component: () => import('@/views/user/components/exportCostGoods/index.vue'),
			}, {
				name: 'exportDownload',
				path: 'exportDownload',
				meta: {
					title: '导出下载'
				},
				component: () => import('@/views/user/components/exportDownload/index.vue'),
			}, {
				name: 'groupExport',
				path: 'groupExport',
				meta: {
					title: '分组导出'
				},
				component: () => import('@/views/user/components/groupExport/index.vue'),
			}, {
				name: 'center',
				path: 'center',
				meta: {
					title: '我的个人中心'
				},
				component: () => import('@/views/user/components/center/index.vue'),
			}, {
				name: 'account',
				path: 'account',
				meta: {
					title: '我的账户'
				},
				component: () => import('@/views/user/components/account/index.vue'),
			}, {
				name: 'goodsShelf',
				path: 'goodsShelf',
				meta: {
					title: '我的货架'
				},
				component: () => import('@/views/user/components/goodsShelf/index.vue'),
			}, {
				name: 'intendingToList',
				path: 'intendingToList',
				meta: {
					title: '变价列表'
				},
				component: () => import('@/views/user/components/intendingToList.vue'),
			}, {
				name: 'address',
				path: 'address',
				meta: {
					title: '我的收货地址'
				},
				component: () => import('@/views/user/components/address/index.vue'),
			}, {
				name: 'coupon',
				path: 'coupon',
				meta: {
					title: '优惠券'
				},
				component: () => import('@/views/user/components/coupon/index.vue'),
			}, {
				name: 'dataBoard',
				path: 'dataBoard',
				meta: {
					title: '数据看板'
				},
				component: () => import('@/views/user/components/dataBoard/index.vue'),
			}, {
				name: 'realtimeBoard',
				path: 'realtimeBoard',
				meta: {
					title: '实时概览'
				},
				component: () => import('@/views/user/components/realtimeBoard/index.vue'),
			}, {
				name: 'personInfo',
				path: 'personInfo',
				meta: {
					title: '个人信息'
				},
				component: () => import('@/views/user/components/personInfo/index.vue'),
			}, {
				name: 'accountManager',
				path: 'accountManager',
				meta: {
					title: '客户经理'
				},
				component: () => import('@/views/user/components/accountManager/index.vue'),
			}, {
				name: 'accountAuthentication',
				path: 'accountAuthentication',
				meta: {
					title: '账号认证'
				},
				component: () => import('@/views/user/components/accountAuthentication/index.vue'),
			}, {
				name: 'accountSecurity',
				path: 'accountSecurity',
				meta: {
					title: '账号安全'
				},
				component: () => import('@/views/user/components/accountSecurity/index.vue'),
			}, {
				name: 'cancellation',
				path: 'cancellation',
				meta: {
					title: '账号注销'
				},
				component: () => import('@/views/user/components/cancellation.vue'),
			}, {
				name: 'role',
				path: 'role',
				meta: {
					title: '角色管理'
				},
				component: () => import('@/views/user/components/role/index.vue'),
			},
			{
				name: 'staff',
				path: 'staff',
				meta: {
					title: '员工管理'
				},
				component: () => import('@/views/user/components/staff/index.vue'),
			},{
				name: 'orderLists',
				path: 'order/lists',
				meta: {
					title: '我的订单'
				},
				component: () => import('@/views/user/components/order/lists/index.vue'),
			}, {
				name: 'orderDetails',
				path: 'order/details',
				meta: {
					title: '订单详情'
				},
				component: () => import('@/views/user/components/order/details/index.vue'),
			}, {
				name: 'orderImport',
				path: 'order/import',
				meta: {
					title: '批量下单'
				},
				component: () => import('@/views/user/components/order/import/index.vue'),
			}, {
				name: 'workOrder',
				path: 'workOrder',
				meta: {
					title: '售后工单'
				},
				component: () => import('@/views/user/components/workOrder/lists/index.vue'),
			}, {
				name: 'workOrderSubmit',
				path: 'workOrder/submit',
				meta: {
					title: '提交工单'
				},
				component: () => import('@/views/user/components/workOrder/submit/index.vue'),
			}, {
				name: 'workOrderDetails',
				path: 'workOrder/details',
				meta: {
					title: '工单详情'
				},
				component: () => import('@/views/user/components/workOrder/details/index.vue'),
			}, {
				name: 'application',
				path: 'application',
				meta: {
					title: '我的应用'
				},
				component: () => import('@/views/user/components/application/index.vue'),
			}, {
				name: 'groupDetail',
				path: 'groupDetail',
				meta: {
					title: '分组详情'
				},
				component: () => import('@/views/user/components/groupDetail/index.vue'),
			}, {
				name: 'notice',
				path: 'notice',
				meta: {
					title: '通知公告'
				},
				component: () => import('@/views/user/components/notice/index.vue'),
			}, {
				name: 'cashAccount',
				path: 'cashAccount',
				meta: {
					title: '提现账户'
				},
				component: () => import('@/views/user/components/cashAccount/index.vue'),
			}, {
				name: 'youzanPlatform',
				path: 'youzanPlatform',
				meta: {
					title: '有赞平台'
				},
				component: () => import('@/views/user/components/platform/youzanPlatform/index.vue'),
			}
			// , {
			// 	name: 'micronePlatform',
			// 	path: 'micronePlatform',
			// 	meta: {
			// 		title: '微盟平台'
			// 	},
			// 	component: () => import('@/views/user/components/platform/micronePlatform/index.vue'),
			// }, {
			// 	name: 'otherPlatform',
			// 	path: 'otherPlatform',
			// 	meta: {
			// 		title: '其他平台'
			// 	},
			// 	component: () => import('@/views/user/components/platform/otherPlatform/index.vue'),
			// }
			,{
				name: 'jushuitanPlatform',
				path: 'jushuitanPlatform',
				meta: {
					title: '聚水潭平台'
				},
				component: () => import('@/views/user/components/platform/jushuitanPlatform/index.vue'),
			}, {
				name: 'gatherPuddle',
				path: 'gatherPuddle',
				meta: {
					title: '聚水潭'
				},
				component: () => import('@/views/user/components/platform/gatherPuddle/index.vue'),
			}, {
				name: 'shopEmpower',
				path: 'shopEmpower',
				meta: {
					title: '授权管理'
				},
				component: () => import('@/views/user/components/platform/components/shopEmpower.vue'),
			}, {
				path: 'workOrderService',
				component: () =>
					import('@/views/user/components/workOrderService.vue'),
				name: 'workOrderService',
				meta: {
					title: '工单服务'
				}
			}, {
				path: 'workOrderServiceInfo',
				component: () =>
					import('@/views/user/components/workOrderServiceInfo.vue'),
				name: 'workOrderServiceInfo',
				meta: {
					title: '工单详情'
				}
			}, {
				path: 'salesRanking',
				component: () =>
					import('@/views/user/components/salesRanking.vue'),
				name: 'salesRanking',
				meta: {
					title: '销量排行'
				}
			}, {
				path: 'msgSubscribe',
				component: () =>
					import('@/views/user/components/msgSubscribe.vue'),
				name: 'msgSubscribe',
				meta: {
					title: '消息订阅'
				}
			}, {
				path: 'helpList',
				component: () =>
					import('@/views/user/components/helpList.vue'),
				name: 'helpList',
				meta: {
					title: '帮助中心'
				}
			}, {
				path: 'mobileApplication',
				component: () =>
					import('@/views/user/components/mobileApplication.vue'),
				name: 'mobileApplication',
				meta: {
					title: '移动应用'
				}
			}, {
				path: 'myMessage',
				component: () =>
					import('@/views/user/components/myMessage.vue'),
				name: 'myMessage',
				meta: {
					title: '移动应用'
				}
			},
			{
				name: 'dailyRecord',
				path: 'dailyRecord',
				meta: {
					title: '登录日志'
				},
				component: () => import('@/views/user/components/dailyRecord/index.vue'),
			},
			{
				name: 'addressManagement',
				path: 'addressManagement',
				meta: {
					title: '地址管理'
				},
				component: () => import('@/views/user/components/addressManagement/index.vue'),
			},
			{
				name: 'virtualOrders',
				path: 'virtualOrders',
				meta: {
					title: '虚拟订单'
				},
				component: () => import('@/views/user/components/virtualOrders/lists/index.vue'),
			},
			{
				name: 'virtualDetails',
				path: 'virtualDetails',
				meta: {
					title: '订单详情'
				},
				component: () => import('@/views/user/components/virtualOrders/details/index.vue'),
			}
		]
	},
	{
		name: 'evaluate',
		path: '/order/evaluate',
		meta: {
			title: '我的评价'
		},
		component: () => import('@/views/evaluate/index.vue'),
	},
	{
		name: 'setAccountSecurity',
		path: '/setAccountSecurity',
		meta: {
			title: '账号安全'
		},
		component: () => import('@/views/setAccountSecurity/index.vue')
	},
	{
		name: 'helpCenter',
		path: '/helpCenter',
		meta: {
			title: '帮助中心'
		},
		component: () => import('@/views/helpCenter/index.vue')
	},
	// {
	// 	name: 'login',
	// 	path: '/login',
	// 	meta: {
	// 		title: '登录'
	// 	},
	// 	component: () => import('@/views/login/index.vue')
	// },
	{
		name: 'forgetPwd',
		path: '/forgetPwd',
		meta: {
			title: '忘记密码'
		},
		component: () => import('@/views/forgetPwd/index.vue')
	},
	{
		name: 'openPlatform',
		path: '/openPlatform',
		meta: {
			title: '开放平台'
		},
		component: () => import('@/views/openPlatform/index.vue')
	},
	{
		name: 'chongZhi',
		path: '/chongZhi',
		meta: {
			title: '充值'
		},
		component: () => import('@/views/chongZhi/index.vue')
	},
	{
		name: 'orderConfirm',
		path: '/orderConfirm',
		meta: {
			title: '订单确认'
		},
		component: () => import('@/views/chongZhi/orderConfirm/index.vue')
	},
	{
		name: 'pay',
		path: '/pay',
		meta: {
			title: '收银台'
		},
		component: () => import('@/views/chongZhi/pay/index.vue')
	},
	{
		name: 'straight',
		path: '/straight',
		meta: {
			title: '直充'
		},
		component: () => import('@/views/chongZhi/straight/index.vue')
	},
	{
		name: 'cami',
		path: '/cami',
		meta: {
			title: '卡密'
		},
		component: () => import('@/views/chongZhi/cami/index.vue')
	},
	{
		name: 'distribution',
		path: '/distribution',
		meta: {
			title: '分销中心'
		},
		component: () => import('@/views/vipZone/distribution/detail/index.vue')
	},
	{
		name: 'distrioderLst',
		path: '/distrioderLst',
		meta: {
			title: '订单列表'
		},
		component: () => import('@/views/vipZone/distribution/oderLst/index.vue')
	},
	{
		path: "*",
		redirect: "/404"
	},
	{
		path: '/404',
		component: () => import('@/views/404'),
		hidden: true
	}
]

const createRouter = () => new Router({
	mode: 'history', // require service support
	scrollBehavior: () => ({
		y: 0
	}),
	routes: routes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}

export default router
